import { FC } from "react";

interface DisabledTextAreaProps {
    value: string;
    wrapClassName?: string;
    restrainerClassName?: string;
    textAreaClassName?: string;
}

const DisabledTextArea: FC<DisabledTextAreaProps> = (props) => {
    return (
        <div className={`textarea-wrap ${props.wrapClassName}`}>
            <div className={`textarea-restrainer ${props.restrainerClassName}`}>
                <textarea
                    disabled
                    value={props.value}
                    className={`textarea scrollbar-popup ${props.textAreaClassName}`}
                />
            </div>
        </div>
    );
};

export default DisabledTextArea;
